export const founders = [
    {
        name: 'Maheshwar Pandey',
        desg: 'Founder and President',
        img: 'https://res.cloudinary.com/dkvuuyi2k/image/upload/v1730804715/MaheshwarPandey_cismls.jpg'
    },
    {
        name: 'Indra Bahadur Chaudhary',
        desg: 'Founder and Secretary',
        img: 'https://res.cloudinary.com/dkvuuyi2k/image/upload/v1730804714/IndraBahadur_gota7w.jpg'
    },
    {
        name: 'Jai Prakash Rai',
        desg: 'Vice President',
        img: 'https://res.cloudinary.com/dkvuuyi2k/image/upload/v1734755220/MrJaiPrakashRai_prkckb.jpg'
    },
    {
        name: 'Chandra Prakash Verma',
        desg: 'Vice President',
        img: 'https://res.cloudinary.com/dkvuuyi2k/image/upload/v1730804713/ChandraPrakashVerma_gajjvx.jpg'
    },
    {
        name: 'Garun Kumar Dubey',
        desg: 'Treasurer',
        img: 'https://res.cloudinary.com/dkvuuyi2k/image/upload/v1730804713/GarudKumarDubey_p1fjco.jpg'
    }
]